import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useSeo } from "@/hooks/useSeo";
import HeroCarousel from "./components/HeroCarousel";
import QuickCategories from "./components/QuickCategories";
import HotMovies from "./components/HotMovies";
import LatestTv from "./components/LatestTv";
import CollectionsSection from "./components/CollectionsSection";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  useSeo({
    title: "天堂电影网 - 高清电影电视剧在线播放平台",
    description:
      "天堂电影网为广大影迷提供丰富的电影和电视剧资源，包括最新大片和经典影片，支持在线观看和内容推荐，带给您极致观影体验。",
    keywords: "天堂电影网,在线观看电影,电视剧资源,高清电影,影视在线播放,电影推荐,影视平台",
  });

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader overlay />
      <main>
        <h1 className="sr-only">天堂电影网 - 高清电影电视剧在线播放平台</h1>
        <HeroCarousel />
        <QuickCategories />
        <HotMovies />
        <LatestTv />
        <CollectionsSection />
        <SiteIntro />
      </main>
      <SiteFooter />
    </div>
  );
}